<div class="flex-grow-1 bg-image">
  <header class="shadow bg-light bg-opacity-50">
    <div class="py-4 container-lg">
      <h4>
        Контакт с нас
      </h4>
      <p class="m-0">
        Свържете се с нас на <strong>{{ supportEmail }}</strong> или изпратете Вашето съобщение чрез формата по-долу.
      </p>
    </div>
  </header>
  <section class="my-3 my-md-5 container-lg">
    <div class="row justify-content-center">
      <div class="col-12 col-md-8 col-xl-6">
        <div class="px-3 border bg-light rounded-3 shadow">
          <header class="py-4 mb-4 border-bottom d-flex align-items-center gap-3">
            <nz-logo height="50"/>
            <h1 class="text-muted">Collectoria</h1>
          </header>
          <main>
            <form [formGroup]="form">
              <fieldset class="mb-4">
                <label for="name" class="mb-0 form-label">Вашето име*</label>
                <input
                  id="name"
                  type="text"
                  formControlName="name"
                  class="form-control"
                  placeholder="Въведете Вашето име..."
                  aria-label="Вашето име"
                  [class.is-valid]="name?.touched && name?.valid"
                  [class.is-invalid]="name?.touched && name?.invalid">
                <p class="invalid-feedback m-0">Задължително поле с максимална дължина от 100 символа!</p>
              </fieldset>
              <fieldset class="mb-4">
                <label for="email" class="mb-0 form-label">Електронна поща</label>
                <input
                  id="email"
                  type="text"
                  formControlName="email"
                  class="form-control"
                  placeholder="Въведете електронна поща..."
                  aria-label="Електронна поща"
                  [class.is-valid]="email?.touched && email?.valid"
                  [class.is-invalid]="email?.touched && email?.invalid">
                <p class="invalid-feedback m-0">Максимална дължина от 100 символа!</p>
              </fieldset>
              <fieldset class="mb-4">
                <label for="phoneNumber" class="mb-0 form-label">Телефонен номер</label>
                <input
                  id="phoneNumber"
                  type="text"
                  formControlName="phoneNumber"
                  class="form-control"
                  placeholder="Въведете телефонен номер..."
                  aria-label="Телефонен номер"
                  [class.is-valid]="phoneNumber?.touched && phoneNumber?.valid"
                  [class.is-invalid]="phoneNumber?.touched && phoneNumber?.invalid">
                <p class="invalid-feedback m-0">Максимална дължина от 100 символа!</p>
              </fieldset>
              <fieldset class="mb-4">
                <label for="message" class="mb-0 form-label">Съобщение*</label>
                <textarea
                  id="message"
                  rows="6"
                  formControlName="message"
                  class="form-control"
                  placeholder="Въведете съобщение..."
                  aria-label="Съобщение"
                  [class.is-valid]="message?.touched && message?.valid"
                  [class.is-invalid]="message?.touched && message?.invalid"></textarea>
                <p class="invalid-feedback m-0">Задължително поле с максимална дължина от 2000 символа!</p>
              </fieldset>
            </form>
            <button
              (click)="onSubmit()"
              [disabled]="loading"
              class="w-100 mb-4 btn btn-nz-primary">
              @if (loading) {
                <span class="me-2 spinner-border spinner-border-sm"></span>
              }
              <span>Изпрати</span>
            </button>
          </main>
        </div>
      </div>
    </div>
  </section>
</div>
